import React, {useState , useEffect , Fragment} from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { faBookOpen, faClose, faCog, faCube, faPhone, faRuler, faShield, faStar, faStarHalfStroke, faSwatchbook} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Bath from '../images/roomicons/bath.png';
import Bedroom from '../images/roomicons/bed.png';
import Dining from '../images/roomicons/dine.png';
import Kitchen from '../images/roomicons/kitchen.png';
import Living from '../images/roomicons/living.png';
import Pooja from '../images/roomicons/pooja.png';
import Balcony from '../images/roomicons/balcony.png';
import Wash from '../images/roomicons/wash.png';
import Header from '../Component/Header';
import ProjectHeader from '../Component/ProjectHeader';


function TilesCustomize() {
    const navigate = useNavigate();
  const location = useLocation();
  const{data} = location.state || {};
  const type = location?.state?.type || {};
  //console.log("Quotation type received:", type);
  const [initialVendors, setInitialVendors] = useState([]);
const [showSaveConfirmPopup, setShowSaveConfirmPopup] = useState(false);
const [hasChanges, setHasChanges] = useState(false);
 const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
const [items, setItems] = useState([]);
  const [selectedFinish ,setSelectedFinish] = useState(null);
  const [selectedSubCategory, setSelectedSubcategory] = useState(null);
  //console.log(selectedSubCategory , selectedFinish)
  const [showVendorPopup, setShowVendorPopup] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState(null);
  //console.log(selectedVendor);
  const [currentVendorIndex, setCurrentVendorIndex] = useState(null); // Store the ID, not the index
  const [showRoomPopup, setShowRoomPopup] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);  // Track the selected item
  const [selectedRooms, setSelectedRooms] = useState({}); // Track selected rooms for each item
  //console.log(selectedRooms);
  const [updatedSampleData, setUpdatedSampleData] = useState(data); // New state for sampleData
console.log("sampleData:", updatedSampleData);
const [unappliedAreas, setUnappliedAreas] = useState([]);
//console.log("unappliedAreas:", unappliedAreas);
const [deselectedAreas, setDeselectedAreas] = useState([]);
const [selectedUnappliedAreas, setSelectedUnappliedAreas] = useState([]);
const [showUnappliedAreaPopup, setShowUnappliedAreaPopup] = useState(false);
const [visibleAreas, setVisibleAreas] = useState(4); // For your "show more" functionality
// Add this state near your other state declarations
const [isApplying, setIsApplying] = useState(false);
const [recentlyAddedAreas, setRecentlyAddedAreas] = useState([]);
//console.log("recentlyAddedAreas:", recentlyAddedAreas);
const [showVendorDetailsPopup, setShowVendorDetailsPopup] = useState(false);
const [selectedVendorDetails, setSelectedVendorDetails] = useState(null);


  useEffect(() => {
    if (data ) {
      setUpdatedSampleData(data); // Initialize updatedSampleData
      fetchItemsofVendors(data);
    }
  }, [data]);

  useEffect(() => {
    if (type && type.toLowerCase().includes('customized')) {
      //console.log("This is a customized quotation");
      // Special handling for customized quotes
      setHasChanges(true); // Set hasChanges to true for customized quotes
    } else {
      //console.log("This is a standard quotation");
      // Standard handling
    }
  }, [type]);
  

 const fetchItemsofVendors = async (quotedata) => {
  try {
    // Extract just the vendor IDs from the vendors data
    const vendorIds = quotedata.vendors.map(vendor => vendor._id);
    /* console.log("Vendor IDs:", vendorIds);
    console.log(quotedata.product_category_id._id); */
    
    // Prepare the URL with query parameters
    let url = `${fetchUrl}product-groups/get-items-by-category-and-vendors?product_category_id=${quotedata.product_category_id._id}&vendorIdString=${vendorIds}`;

    // Get the token from session storage
    const token = sessionStorage.getItem('token');
    
    if (!token) {
      throw new Error('Authentication token not found');
    }
    
    // Make the API call with the authorization header
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'x-token': token,
        'Content-Type': 'application/json'
      }
    });
    
    if (!response.ok) {
      throw new Error('Failed to fetch items of vendors');
    }
    
    const data = await response.json();
    /* //console.log(data); */
    
    if (data.success) {
      // Transform the items
      const transformedItems = data.data.map(transformItemId);
      console.log(transformedItems);
      
      // Update the updatedSampleData by adding new items without duplicating existing ones
      setUpdatedSampleData(prevData => {
        // Create a Set of existing item IDs for quick lookup
        const existingItemIds = new Set(prevData.items.map(item => item.item_id));
        
        // Filter out items that already exist in updatedSampleData.items
        const newItems = transformedItems.filter(item => !existingItemIds.has(item.item_id));
        
        // For each new item, initialize applied_areas, quantity, and total
        const preparedNewItems = newItems.map(item => ({
          ...item,
          applied_areas: [],
          quantity: 0,
          total: 0,
          total_tax_amount: 0
        }));
        
        // Return the updated state with new items added
        return {
          ...prevData,
          items: [...prevData.items, ...preparedNewItems]
        };
      });
      
      return data;
    }
  } catch (error) {
    console.error('Error fetching items of vendors:', error);
    return null;
  }
}; 

  
  

  const handleVendorChangeClick = (vendorId , vendor,categoryId) => {
    //console.log(vendor.product_subcategory_data)
    //console.log(categoryId)
    const subcategoryIds = vendor.product_subcategory_data.map(sub => sub._id);
//console.log(subcategoryIds);
    // Function to fetch brands from the API
const fetchBrands = async () => {
  
    try {
      // Construct the API endpoint URL
      const url = `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/quotations/get-brands?product_category_id=${categoryId._id}&product_sub_category_ids=${subcategoryIds}`;
  
      // Make the fetch request
      const response = await fetch(url);
  
      // Check if the response is ok
      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }
  
      // Parse the response as JSON
      const data = await response.json();
      //console.log(data)
      // Handle the retrieved data (Assuming data.data contains the required brands info)
      if (data.success) {
        setShowVendorPopup(true);
        setInitialVendors(data.data);
        //console.log(data.data);
        setCurrentVendorIndex(vendorId);
        setSelectedVendor(vendor._id);  
      } else {
        console.error('Error:', data.message);
      }
    } catch (error) {
      console.error('Fetch error:', error);
    }
  };
  fetchBrands();
  };

  const handleVendorChange = () => {
    if (selectedVendor && currentVendorIndex !== null && updatedSampleData) {
      const newVendor = Object.values(initialVendors).find(
        (vendor) => vendor._id === selectedVendor
      );
  
      if (newVendor) {
        const newUpdatedSampleData = JSON.parse(JSON.stringify(updatedSampleData));
        newUpdatedSampleData.vendors[currentVendorIndex] = newVendor;
  
        const newVendorItems = items.filter(
          (item) => item.vendor._id === selectedVendor
        );
  
        const updatedItems = [];
        const matchedNewItemIds = new Set();
  
        newUpdatedSampleData.items.forEach((existingItem) => {
          const matchingNewItem = newVendorItems.find((newItem) => {
            if (newItem.product_subcategory.name !== existingItem.product_subcategory.name) {
              return false;
            }
  
            const existingFinishAttr = existingItem.attributes.find(
              (attr) => attr.attribute_name === "finish"
            );
            const newFinishAttr = newItem.attributes.find(
              (attr) => attr.attribute_name === "finish"
            );
  
            return (
              existingFinishAttr &&
              newFinishAttr &&
              existingFinishAttr.attribute_value === newFinishAttr.attribute_value
            );
          });
  
          if (matchingNewItem) {
            matchedNewItemIds.add(matchingNewItem._id || matchingNewItem.item_id);
  
            const totalAreaInSft = existingItem.applied_areas.reduce(
              (sum, area) => sum + area.areaInSft,
              0
            );
  
            const sqFtPerBoxAttr = matchingNewItem.attributes.find(
              (attr) => attr.attribute_name === "Sq Ft per Box"
            );
            const sqFtPerBox = sqFtPerBoxAttr ? parseFloat(sqFtPerBoxAttr.attribute_value) : 1;
  
            const quantity = Math.ceil(totalAreaInSft / sqFtPerBox);
            const total = quantity * matchingNewItem.selling_price;
  
            updatedItems.push({
              ...matchingNewItem,
              applied_areas: existingItem.applied_areas,
              quantity,
              total,
            });
          } else {
            updatedItems.push(existingItem);
            console.log("No matching new item found for:", existingItem);
            console.log("NupdatedItems:", updatedItems);
          }
        });
  
        newVendorItems.forEach((newItem) => {
          const id = newItem._id || newItem.item_id;
          if (!matchedNewItemIds.has(id)) {
            updatedItems.push({
              ...newItem,
              applied_areas: [],
              quantity: 0,
              total: 0,
            });
          }
        });
  
        const transformedItems = updatedItems.map(transformItemId);
  
        const overallTotalPrice = transformedItems.reduce(
          (sum, item) => sum + item.total,
          0
        );
  
        setUpdatedSampleData((prevData) => ({
          ...prevData,
          vendors: newUpdatedSampleData.vendors,
          items: transformedItems,
          total: overallTotalPrice,
        }));
  
        setSelectedVendor(null);
        setShowVendorPopup(false);
        setCurrentVendorIndex(null);
      } else {
        console.error("Selected vendor not found in initialVendors:", selectedVendor);
      }
    }
  };
  

  const transformItemId = (item) => {
    const { _id, product_subcategory, ...rest } = item;
  
    const transformedProductSubcategory = {
      ...product_subcategory,
      name: product_subcategory?.name || product_subcategory?.product_sub_category_name || '',
    };
  
    return {
      item_id: _id,
      ...rest,
      product_subcategory: transformedProductSubcategory,
    };
  };

   
// useEffect hook to call fetchItems when selectedVendor changes
useEffect(() => {
  if (selectedVendor) {
    fetchItems(selectedVendor);
  }
}, [selectedVendor]);

const fetchItems = async (vendorId) => {
  const PCid = updatedSampleData.product_category_id._id;
  //console.log(PCid);
  try {
    // Construct the API endpoint URL
    const url = `${process.env.REACT_APP_FORE_BRICKBUCKET}product-groups/get-items-by-category-and-vendor?product_category_id=${PCid}&vendor_id=${vendorId}`;

    // Make the fetch request
    const response = await fetch(url);

    // Check if the response is ok
    if (!response.ok) {
      throw new Error(`Network response was not ok: ${response.statusText}`);
    }

    // Parse the response as JSON
    const data = await response.json();

    // Handle the retrieved data
    if (data.success) {
      // Transform each item using transformItemId
      const transformedItems = data.data.map(transformItemId);

      // Update the state with transformed items
      setItems(transformedItems);
      console.log(transformedItems);
    } else {
      console.error('Error:', data.message);
    }
  } catch (error) {
    console.error('Fetch error:', error);
  }
};



  const handleRadioChange = (vendorId) => {
    setSelectedVendor(vendorId);
  };


  // Create a set of all unique room names from sampleData.items
  const allRooms = new Set();

  data.items.forEach(item => {
    item.applied_areas.forEach(area => {
      if (area.area_name) {
        allRooms.add(area.area_name);
      }
    });
  });
 
  //console.log([...allRooms]); // To see the unique area names
 
// Create a lookup map for all areas across all items:
const allAreasMap = new Map();
updatedSampleData.items.forEach(item => {
  item.applied_areas.forEach(area => {
    allAreasMap.set(area.area_name, area); // Store area details by area_name
  });
});

// ... inside handleRoomChangeClick ...
const handleRoomChangeClick = (item) => {
  setSelectedItem(item);
  // Don't set default finish and subcategory
  setSelectedFinish(null);
  setSelectedSubcategory(null);
  
  const initialSelectedRooms = {};
  
  // Only include areas from the clicked item and unapplied areas
  // First, add the item's applied areas
  item.applied_areas.forEach(area => {
    initialSelectedRooms[area.area_name] = {
      selected: false, // Not selected by default
      _id: area._id,
      area_name: area.area_name,
      areaInSft: area.areaInSft,
      fromSelectedItem: true
    };
  });
  
  // Then add any unapplied areas that aren't already included
  unappliedAreas.forEach(area => {
    if (!initialSelectedRooms[area.area_name]) {
      initialSelectedRooms[area.area_name] = {
        selected: false,
        _id: area._id,
        area_name: area.area_name,
        areaInSft: area.areaInSft,
        fromSelectedItem: false
      };
    }
  });

  setSelectedRooms(initialSelectedRooms);
  setShowRoomPopup(true);
};


const handleReapplyRecentArea = (area) => {
  setSelectedRooms(prev => ({
    ...prev,
    [area.area_name]: {
      _id: area._id,
      area_name: area.area_name,
      areaInSft: area.areaInSft,
      selected: true,
      fromSelectedItem: false,
    },
  }));
};




// This function applies the changes when the user clicks "Apply Changes"
const handleRoomChange = () => {
  if (!selectedItem || !selectedFinish || !selectedSubCategory) return;

  // Create a deep copy of the updatedSampleData to avoid direct state mutation
  const newUpdatedSampleData = JSON.parse(JSON.stringify(updatedSampleData));

  // Find the index of the item that matches the selected finish and subcategory
  const matchedItemIndex = newUpdatedSampleData.items.findIndex(item => {
    const hasMatchingSubcategory = item.product_subcategory?.name === selectedSubCategory;
    const hasMatchingFinish = item.attributes?.some(
      attr => attr.attribute_name === "finish" && attr.attribute_value === selectedFinish.attribute_value
    );
    return hasMatchingSubcategory && hasMatchingFinish;
  });

  if (matchedItemIndex !== -1) {
    const matchedItem = newUpdatedSampleData.items[matchedItemIndex];
    
    // Get the 'Sq Ft per Box' attribute value
    const sqFtPerBoxAttr = matchedItem.attributes.find(attr => attr.attribute_name === "Sq Ft per Box");
    const sqFtPerBox = sqFtPerBoxAttr ? parseFloat(sqFtPerBoxAttr.attribute_value) : 1;

    // Process deselected areas from the original item first
    let newUnappliedAreas = [...unappliedAreas];
    
    // Check if we're modifying the same item that was originally selected
    const isModifyingSameItem = selectedItem.item_id === matchedItem.item_id;
    
    if (isModifyingSameItem) {
      // We're modifying the same item, so we should remove deselected rooms
      const remainingAreas = [];
      matchedItem.applied_areas.forEach(area => {
        const isDeselected = deselectedAreas.some(deselected => deselected._id === area._id);
        if (isDeselected) {
          // Add to unappliedAreas if not already present
          if (!newUnappliedAreas.some(unapplied => unapplied._id === area._id)) {
            newUnappliedAreas.push(area);
          }
        } else {
          remainingAreas.push(area);
        }
      });
      matchedItem.applied_areas = remainingAreas;
    } else {
      // We're changing to a different item
      // In this case, we DON'T remove any rooms from the original item
      // We only apply the currently selected rooms to the new item
      
      // No need to modify the original item's applied_areas
    }

    // Get newly selected rooms from UI state (only the ones that are currently checked)
const newlySelectedRooms = Object.keys(selectedRooms)
.filter(room => selectedRooms[room].selected)
.map(room => {
  // If this room is in unappliedAreas, use that data
  const unappliedArea = newUnappliedAreas.find(area => area.area_name === room);
  if (unappliedArea) {
    // Remove it from unappliedAreas since we're now applying it
    newUnappliedAreas = newUnappliedAreas.filter(area => area._id !== unappliedArea._id);
    return unappliedArea;
  }
  
  // Otherwise use the data from selectedRooms
  return {
    _id: selectedRooms[room]._id,
    area_name: selectedRooms[room].area_name,
    areaInSft: selectedRooms[room].areaInSft
  };
});


    // Filter out rooms that are already applied to the matched item to avoid duplication
    const existingRoomIds = new Set(matchedItem.applied_areas.map(area => area._id));
    const uniqueNewRooms = newlySelectedRooms.filter(room => !existingRoomIds.has(room._id));

    // Append unique newly selected rooms to the existing applied_areas of the matched item
    matchedItem.applied_areas = [...matchedItem.applied_areas, ...uniqueNewRooms];

    // Remove selected areas from other items to avoid duplication
    // This ensures a room can only be applied to one item at a time
    uniqueNewRooms.forEach(newArea => {
      newUpdatedSampleData.items.forEach((item, idx) => {
        if (idx !== matchedItemIndex) {
          item.applied_areas = (item.applied_areas || []).filter(area => area._id !== newArea._id);
          
          // Remove from unappliedAreas as well
          newUnappliedAreas = newUnappliedAreas.filter(area => area._id !== newArea._id);
        }
      });
    });

    // Recalculate metrics for all items
    newUpdatedSampleData.items.forEach(item => {
      const itemTotalAreaInSft = item.applied_areas.reduce((sum, area) => sum + (area.areaInSft || 0), 0);
      const itemSqFtPerBoxAttr = item.attributes.find(attr => attr.attribute_name === "Sq Ft per Box");
      const itemSqFtPerBox = itemSqFtPerBoxAttr ? parseFloat(itemSqFtPerBoxAttr.attribute_value) : 1;
      
      // Round up the quantity to the next integer
      const rawItemQuantity = itemSqFtPerBox > 0 ? itemTotalAreaInSft / itemSqFtPerBox : 0;
      item.quantity = Math.ceil(rawItemQuantity);
      
      // Round up the total price to the next integer
      const rawItemTotalPrice = item.quantity * item.selling_price;
      item.total = Math.ceil(rawItemTotalPrice);
      
      // Calculate the tax amount based on the item's total and tax rate
      const taxRate = item.tax_rate || 0; // Default to 0 if tax_rate is not defined
      item.total_tax_amount = Math.ceil(item.total * (taxRate / 100));
    });
    
    
    // Calculate overall total
    // Calculate overall subtotal
const overallSubTotal = newUpdatedSampleData.items.reduce((sum, item) => sum + (item.total || 0), 0);
newUpdatedSampleData.subtotal = overallSubTotal;

// Calculate overall tax amount (sum of all items' tax amounts)
const overallTaxAmount = newUpdatedSampleData.items.reduce((sum, item) => sum + (item.total_tax_amount || 0), 0);
newUpdatedSampleData.tax_amount = overallTaxAmount;

// Calculate the final total (subtotal + tax)
newUpdatedSampleData.total = overallSubTotal + overallTaxAmount;

    // Update the state with the new data
    setUpdatedSampleData(newUpdatedSampleData);
    setUnappliedAreas(newUnappliedAreas);
  }

  // Reset UI state
  //setShowRoomPopup(false);
  //setSelectedItem(null);
  setSelectedRooms({});
  setSelectedFinish(null);
  setSelectedSubcategory(null);
  setDeselectedAreas([]); // Clear the deselectedAreas array
};

// Create a modified version of handleRoomChange that includes the applying effect
const handleModifiedRoomChange = () => {
  if (!selectedItem || !selectedFinish || !selectedSubCategory) return;
  
  // Start the applying effect
  setIsApplying(true);
  
  // Create a temporary overlay for visual feedback
  const applyingOverlay = document.createElement('div');
  applyingOverlay.className = 'fixed inset-0 bg-white bg-opacity-50 z-50 flex items-center justify-center transition-opacity duration-500';
  applyingOverlay.innerHTML = `
    <div class="bg-white p-4 rounded-lg shadow-lg">
      <div class="flex items-center">
        <svg class="animate-spin h-5 w-5 mr-3 text-[#C20C0C]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        <span class="text-[#C20C0C] font-medium">Applying changes...</span>
      </div>
    </div>
  `;
  document.body.appendChild(applyingOverlay);
  
  // Get the newly selected rooms before applying changes
  const newlySelectedRooms = Object.keys(selectedRooms)
    .filter(room => selectedRooms[room].selected)
    .map(room => ({
      ...selectedRooms[room],
      itemName: selectedItem.item_name,
      newItemName: updatedSampleData.items.find(item => 
        item.product_subcategory.name === selectedSubCategory && 
        item.attributes?.some(attr => 
          attr.attribute_name === "finish" && 
          attr.attribute_value === selectedFinish.attribute_value
        )
      )?.item_name
    }));
  
  // Use setTimeout to simulate processing time and allow the UI to update
  setTimeout(() => {
    // Call the original handler
    handleRoomChange();
    
    // Update recently added areas
    setRecentlyAddedAreas(prev => {
  // Create a map of existing areas by area_name for quick lookup
  const existingAreasMap = new Map(
    prev.map(item => [item.area_name, item])
  );
  
  // Process new areas
  const newAreas = [];
  
  newlySelectedRooms.forEach(room => {
    // Find the original item and new item
    const originalItem = selectedItem || {};
    const newItem = updatedSampleData.items.find(item => 
      item.product_subcategory.name === selectedSubCategory && 
      item.attributes?.some(attr => 
        attr.attribute_name === "finish" && 
        attr.attribute_value === selectedFinish.attribute_value
      )
    ) || {};
    
    // Create the new area entry with timestamp and item IDs
    const newAreaEntry = {
      ...room,
      timestamp: new Date().getTime(),
      originalItemId: originalItem.item_id || originalItem._id,
      newItemId: newItem.item_id || newItem._id,
      originalItemName: originalItem.item_name,
      newItemName: newItem.item_name
    };
    
    // Add to newAreas array (will replace any existing entry with same name)
    newAreas.push(newAreaEntry);
    
    // Remove from existingAreasMap if it exists there
    existingAreasMap.delete(room.area_name);
  });
  
  // Combine new areas with remaining existing areas
  return [
    ...newAreas,
    ...Array.from(existingAreasMap.values())
  ];
});


    
    // Remove the overlay
    document.body.removeChild(applyingOverlay);
    
    // Reset the applying state
    setIsApplying(false);
    
    // Reset selections for the next change
    const resetSelectedRooms = {};
    Object.keys(selectedRooms).forEach(room => {
      if (selectedRooms[room].selected) {
        // Remove selected rooms from the options
        delete resetSelectedRooms[room];
      } else {
        // Keep unselected rooms
        resetSelectedRooms[room] = {...selectedRooms[room]};
      }
    });
    
    // Only reset if there are still rooms to select
    if (Object.keys(resetSelectedRooms).length > 0) {
      setSelectedRooms(resetSelectedRooms);
      setSelectedFinish(null);
      setSelectedSubcategory(null);
    } else {
      // If no rooms left, close the popup
      setShowRoomPopup(false);
      setRecentlyAddedAreas([]);
    }
  }, 1000); // 1 second delay for the effect
};


// This function tracks which rooms are being selected/deselected in the UI
const handleCheckboxChange = (room) => {
  console.log(room);
  setSelectedRooms((prevSelectedRooms) => {
    const isSelected = prevSelectedRooms[room].selected;
    const updatedRooms = {
      ...prevSelectedRooms,
      [room]: {
        ...prevSelectedRooms[room],
        selected: !isSelected,
      },
    };

    // We'll still track deselected areas, but we'll use them differently
    // depending on whether we're changing items or not
    if (isSelected) {
      // Room is being deselected
      setDeselectedAreas((prevDeselectedAreas) => {
        // Check if the room is already in deselectedAreas to avoid duplicates
        const isAlreadyDeselected = prevDeselectedAreas.some(
          (area) => area.area_name === room
        );

        if (!isAlreadyDeselected) {
          return [
            ...prevDeselectedAreas,
            {
              _id: prevSelectedRooms[room]._id,
              area_name: room,
              areaInSft: prevSelectedRooms[room].areaInSft,
              // Add a flag to track if this was originally from the selected item
              fromSelectedItem: prevSelectedRooms[room].fromSelectedItem || false
            },
          ];
        }
        return prevDeselectedAreas;
      });
    } else {
      // Room is being selected
      setDeselectedAreas((prevDeselectedAreas) =>
        prevDeselectedAreas.filter((area) => area.area_name !== room)
      );
    }

    return updatedRooms;
  });
};


 
// ... other code

const handleFinishChange = (subcategoryName, selectedFinishValue) => {
  setSelectedSubcategory(subcategoryName);
  setSelectedFinish(selectedFinishValue);
console.log(selectedFinishValue, subcategoryName);
  if (selectedItem) {
    // Preserve other attributes and update only the Finish attribute
    const updatedAttributes = [
      ...(selectedItem.attributes || []).filter(attr => attr.attribute_name !== "finish"),
      {
        attribute_name: "finish",
        attribute_value: selectedFinishValue
      }
    ];

    // Find the full subcategory object
    const fullSubcategory = Object.values(updatedSampleData.vendors)
      .flatMap(vendor => vendor.product_subcategory_data)
      .find(sub => sub.name === subcategoryName) || { name: subcategoryName };

    const updatedItem = {
      ...selectedItem,
      product_subcategory: fullSubcategory,
      attributes: updatedAttributes,
    };

    setSelectedItem(updatedItem);
    //console.log(updatedItem);
    // Update main sample data
   /*  setUpdatedSampleData(prevData => {
      const updatedItems = prevData.items.map(item =>
        item.vendor_id + item.item_name === selectedItem.vendor_id + selectedItem.item_name
          ? updatedItem
          : item
      );
      return { ...prevData, items: updatedItems };
    }); */
  }
};

// const handleSaveQuote = async () => {
  
//   try {
//     // Ensure project_id and product_category_id are set correctly
//     const projectId = updatedSampleData.project_id?._id || updatedSampleData.project_id;
//     const productCategoryId = updatedSampleData.product_category_id?._id || updatedSampleData.product_category_id;

//     // Destructure to remove `_id` from the root level
//     const { _id, package_id, package_name, ...restSampleData } = updatedSampleData;

//     // Filter out items with no applied_areas
//     const filteredItems = restSampleData.items?.filter(
//       item => Array.isArray(item.applied_areas) && item.applied_areas.length > 0
//     ) || [];

//     // Compose the final data object for request
//     const quotationData = {
//       ...restSampleData,
//       project_id: projectId,
//       product_category_id: productCategoryId,
//       items: filteredItems,
//     };

//     const token = sessionStorage.getItem('token');
//     const response = await fetch(`${fetchUrl}customer/quotations/save-quotation`, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//         'x-token': token,
//       },
//       body: JSON.stringify(quotationData),
//     });

//     const data = await response.json();
//     if (data.success) {
//       console.log('Quotation saved successfully');
//       console.log('Quotation Response data:', data);
// console.log('P ', data.data.project_id);
//       // Navigate to TilesStandardQuoteDetails screen with quotationId
//       navigate('/consumer/projectDetails', {
//         p: data.data.project_id,
//       });
//     }
//   } catch (error) {
//     console.error('Failed to save quotation:', error);
//   }
// };

// Replace your existing handleSaveQuote function with this one
const handleSaveQuote = async () => {
  // Check if this is a customized quotation
  if (type && type.toLowerCase().includes('customized')) {
    // Show confirmation popup for customized quotes
    setShowSaveConfirmPopup(true);
    return;
  }
  
  // For standard quotations, proceed with saving
  try {
    // Ensure project_id and product_category_id are set correctly
    const projectId = updatedSampleData.project_id?._id || updatedSampleData.project_id;
    const productCategoryId = updatedSampleData.product_category_id?._id || updatedSampleData.product_category_id;

    // Destructure to remove `_id` from the root level
    const { _id, package_id, package_name, ...restSampleData } = updatedSampleData;

    // Filter out items with no applied_areas
    const filteredItems = restSampleData.items?.filter(
      item => Array.isArray(item.applied_areas) && item.applied_areas.length > 0
    ) || [];

    // Compose the final data object for request
    const quotationData = {
      ...restSampleData,
      project_id: projectId,
      product_category_id: productCategoryId,
      items: filteredItems,
      quotation_date:new Date().toISOString(),
    };

    const token = sessionStorage.getItem('token');
    const response = await fetch(`${fetchUrl}customer/quotations/save-quotation`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token,
      },
      body: JSON.stringify(quotationData),
    });

    const data = await response.json();
    if (data.success) {
      console.log('Quotation saved successfully');
      console.log('Quotation Response data:', data);
      console.log('P ', data.data.project_id);

      // Navigate to TilesStandardQuoteDetails screen with quotationId
      navigate('/consumer/app/home', {
        p: data.data.project_id,
      });
    }
  } catch (error) {
    console.error('Failed to save quotation:', error);
  }
};

const handleReplaceOriginal = async () => {
  try {
    // Ensure project_id and product_category_id are set correctly
    const projectId = updatedSampleData.project_id?._id || updatedSampleData.project_id;
    const productCategoryId = updatedSampleData.product_category_id?._id || updatedSampleData.product_category_id;

    // Get the original quotation ID - ensure it's a string
    const quotationId = updatedSampleData._id.toString().trim();
    console.log('Using quotation ID:', quotationId);

    // Filter out items with no applied_areas
    const filteredItems = updatedSampleData.items?.filter(
      item => Array.isArray(item.applied_areas) && item.applied_areas.length > 0
    ) || [];

    // Prepare the update data
    const updateData = {
      project_id: projectId,
      product_category_id: productCategoryId,
      items: filteredItems,
      customer_id: updatedSampleData.customer_id,
      subtotal: updatedSampleData.subtotal,
      tax_amount: updatedSampleData.tax_amount,
      total: updatedSampleData.total,
      status: updatedSampleData.status || 'Draft',
      quotation_type: updatedSampleData.quotation_type,
      quotation_date:new Date().toISOString(),
    };

    const token = sessionStorage.getItem('token');
    
    // Try with the quotation_id in the query params
    const response = await fetch(`${fetchUrl}customer/quotations/update-quotation?quotation_id=${quotationId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token,
      },
      body: JSON.stringify({
        ...updateData,
        quotation_id: quotationId  // Include the ID in the body as well for redundancy
      }),
    });

    // Check if response is ok before parsing JSON
    if (!response.ok) {
      const errorText = await response.text();
      console.error('Error response:', errorText);
      throw new Error(`Server responded with ${response.status}: ${errorText}`);
    }

    const data = await response.json();
    
    if (data.success) {
      console.log('Original quotation updated successfully');
      console.log('Quotation Response data:', data);
      
      // After successful save
      setShowSaveConfirmPopup(false);
      
      // Navigate back to project details
      navigate('/consumer/projectDetails', {
        p: projectId,
      });
    } else {
      console.error('Failed to update quotation:', data.message);
      alert('Failed to update quotation: ' + (data.message || 'Unknown error'));
    }
  } catch (error) {
    console.error('Failed to update quotation:', error);
    alert('An error occurred while updating the quotation: ' + error.message);
  }
};





const handleSaveCopy = async () => {
  try {
    // Ensure project_id and product_category_id are set correctly
    const projectId = updatedSampleData.project_id?._id || updatedSampleData.project_id;
    const productCategoryId = updatedSampleData.product_category_id?._id || updatedSampleData.product_category_id;

    // Destructure to remove `_id` from the root level
    const { _id, package_id, package_name, ...restSampleData } = updatedSampleData;

    // Filter out items with no applied_areas
    const filteredItems = restSampleData.items?.filter(
      item => Array.isArray(item.applied_areas) && item.applied_areas.length > 0
    ) || [];

    // Compose the final data object for request
    const quotationData = {
      ...restSampleData,
      quotation_date: new Date().toISOString(),
      project_id: projectId,
      product_category_id: productCategoryId,
      items: filteredItems,
    };

    const token = sessionStorage.getItem('token');
    const response = await fetch(`${fetchUrl}customer/quotations/save-quotation`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token,
      },
      body: JSON.stringify(quotationData),
    });

    const data = await response.json();
    if (data.success) {
      console.log('Quotation saved successfully');
      console.log('Quotation Response data:', data);
console.log('P ', data.data.project_id);
      // Navigate to TilesStandardQuoteDetails screen with quotationId
      navigate('/consumer/projectDetails', {
        p: data.data.project_id,
      });
    }
  } catch (error) {
    console.error('Failed to save quotation:', error);
  }
};



const handleApplyUnappliedAreas = () => {
  if (!selectedFinish || !selectedSubCategory) return;

  // Create a deep copy of the updatedSampleData
  const newUpdatedSampleData = JSON.parse(JSON.stringify(updatedSampleData));

  // Find the index of the item that matches the selected finish and subcategory
  const matchedItemIndex = newUpdatedSampleData.items.findIndex(item => {
    const hasMatchingSubcategory = item.product_subcategory?.name === selectedSubCategory;
    const hasMatchingFinish = item.attributes?.some(
      attr => attr.attribute_name === "finish" && attr.attribute_value === selectedFinish.attribute_value
    );
    return hasMatchingSubcategory && hasMatchingFinish;
  });

  if (matchedItemIndex !== -1) {
    const matchedItem = newUpdatedSampleData.items[matchedItemIndex];
    
    // Get the 'Sq Ft per Box' attribute value
    const sqFtPerBoxAttr = matchedItem.attributes.find(attr => attr.attribute_name === "Sq Ft per Box");
    const sqFtPerBox = sqFtPerBoxAttr ? parseFloat(sqFtPerBoxAttr.attribute_value) : 1;

    // Filter out areas that are already applied to avoid duplication
    const existingRoomIds = new Set(matchedItem.applied_areas.map(area => area._id));
    const uniqueNewAreas = selectedUnappliedAreas.filter(area => !existingRoomIds.has(area._id));

    // Append unique newly selected areas to the existing applied_areas
    matchedItem.applied_areas = [...matchedItem.applied_areas, ...uniqueNewAreas];

    // Remove these areas from unappliedAreas
    const newUnappliedAreas = unappliedAreas.filter(area => 
      !selectedUnappliedAreas.some(selected => selected._id === area._id)
    );

    // Recalculate metrics for all items
    newUpdatedSampleData.items.forEach(item => {
      const itemTotalAreaInSft = item.applied_areas.reduce((sum, area) => sum + (area.areaInSft || 0), 0);
      const itemSqFtPerBoxAttr = item.attributes.find(attr => attr.attribute_name === "Sq Ft per Box");
      const itemSqFtPerBox = itemSqFtPerBoxAttr ? parseFloat(itemSqFtPerBoxAttr.attribute_value) : 1;
      
      // Round up the quantity to the next integer
      const rawItemQuantity = itemSqFtPerBox > 0 ? itemTotalAreaInSft / itemSqFtPerBox : 0;
      item.quantity = Math.ceil(rawItemQuantity);
      
      // Round up the total price to the next integer
      const rawItemTotalPrice = item.quantity * item.selling_price;
      item.total = Math.ceil(rawItemTotalPrice);
      
      // Calculate tax amount
      const taxRate = item.tax_rate || 0;
      item.total_tax_amount = Math.ceil(item.total * (taxRate / 100));
    });
    
    // Calculate overall subtotal and tax
    const overallSubTotal = newUpdatedSampleData.items.reduce((sum, item) => sum + (item.total || 0), 0);
    const overallTaxAmount = newUpdatedSampleData.items.reduce((sum, item) => sum + (item.total_tax_amount || 0), 0);
    
    newUpdatedSampleData.subtotal = overallSubTotal;
    newUpdatedSampleData.tax_amount = overallTaxAmount;
    newUpdatedSampleData.total = overallSubTotal + overallTaxAmount;

    // Update the state
    setUpdatedSampleData(newUpdatedSampleData);
    setUnappliedAreas(newUnappliedAreas);
    
    // Reset UI state
    setSelectedUnappliedAreas([]);
    setShowUnappliedAreaPopup(false);
    setSelectedFinish(null);
    setSelectedSubcategory(null);
  }
};

const handleUnappliedAreaSelect = (area) => {
  // Use a callback function to ensure we're working with the latest state
  setSelectedUnappliedAreas(prev => {
    // Check if area is already selected
    const isAlreadySelected = prev.some(a => a._id === area._id);
    
    // Create a new array to trigger a re-render
    if (isAlreadySelected) {
      // If already selected, filter it out
      return prev.filter(a => a._id !== area._id);
    } else {
      // If not selected, add it
      return [...prev, area];
    }
  });
};

const handleCloseShowRoomPopup = () => {
  setShowRoomPopup(false);
  setRecentlyAddedAreas([]); // Clear recently added areas
};

      // Helper function to get the appropriate icon based on area name
const getRoomIcon = (areaName) => {
  const lowerCaseName = areaName.toLowerCase();
  
  if (lowerCaseName.includes('bath')) return Bath;
  if (lowerCaseName.includes('bed') || lowerCaseName.includes('master')) return Bedroom;
  if (lowerCaseName.includes('dining') || lowerCaseName.includes('dine')) return Dining;
  if (lowerCaseName.includes('kitchen')) return Kitchen;
  if (lowerCaseName.includes('living') || lowerCaseName.includes('hall')) return Living;
  if (lowerCaseName.includes('pooja') || lowerCaseName.includes('prayer')) return Pooja;
  if (lowerCaseName.includes('balcony') || lowerCaseName.includes('terrace')) return Balcony;
  if (lowerCaseName.includes('wash') || lowerCaseName.includes('utility')) return Wash;
  
  // Default to Living room icon if no match is found
  return Living;
};


// Add this function to handle clicking on the vendor image
const handleVendorImageClick = (vendor) => {
  setSelectedVendorDetails(vendor);
  setShowVendorDetailsPopup(true);
};
console.log("data:---",data)
  return (
    <div className="bg-gray-100 ">
      <Header />
   
      <ProjectHeader 
        projectName={data?.project_id?.projectName}
        type={'Customizing Quote'}
        categoryName={data?.customized_by 
          ? data.quotation_number 
          : (data?.package_name || data?.quotation_number)
        }
        buildcoins={
      data?.buildcoins && Array.isArray(data.buildcoins)
        ? data.buildcoins.reduce((sum, item) => sum + (item?.reserved_coins ?? 0), 0)
        : 0
    }        
                />


         {/* Applied Tiles Brands starts */}
         <div className='px-4'>
  {/* Header row */}
  <div className="mt-2 flex justify-between items-center mb-2">
    <h2 className="text-base font-semibold">Choose Brand</h2>
  </div>

  {/* Vendor listings */}
  {updatedSampleData?.vendors &&
    Object.entries(updatedSampleData.vendors).map(([vendorId, vendor]) => (
      <div key={vendorId} className="flex flex-col border-b pb-2">
        <div className="flex items-start p-3 bg-white rounded-lg shadow-sm">
  {/* Left side - Vendor image and change button */}
  <div onClick={() => handleVendorChangeClick(vendorId, vendor, updatedSampleData?.product_category_id)}
  className="flex flex-col items-center mr-4">
    <img
      src={process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES + vendor.image}
      alt={vendor.name}
      className="border w-20 h-16 rounded-md object-contain mb-2"
    />
    <button
      onClick={() => handleVendorChangeClick(vendorId, vendor, updatedSampleData?.product_category_id)}
      className="w-full text-xs border border-[#e8001c] text-[#e8001c] font-medium py-1.5 px-3 rounded-md  transition-colors focus:outline-none focus:ring-2 focus:ring-[#e8001c] focus:ring-opacity-50"
    >
      Change
    </button>
  </div>
  
  {/* Right side - Product details */}
  <div className="flex-grow">
    {/* Vendor name */}
{/*     <h3 className="font-semibold text-gray-800 mb-2">{vendor.name}</h3> */}
    
    {/* Table header */}
    <div className="flex justify-around mb-1 text-xs text-gray-500 border-b pb-1">
      <span>Available Sizes</span>
      <span className="text-right">Starts from</span>
    </div>
    
    {/* Product subcategories */}
    <div className="space-y-0.5 mt-1">
      {vendor.product_subcategory_data.map((product) => (
        <div key={product._id} className="flex justify-around items-center">
          <span className="text-sm font-medium text-gray-700">{product.product_sub_category_name}</span>
          <div className="text-right">
            <span className="text-sm font-semibold text-[#e8001c]">
              ₹{product?.selling_price}
            </span>
            <span className="text-xs text-gray-500">/Box</span>
          </div>
        </div>
      ))}

    </div>
  </div>
</div>


      </div>
    ))}
</div>

      {/* Applied Tiles Brands ends */}


{/* Vendors list popup starts */}
{showVendorPopup && (
  <div className="fixed inset-0 z-40 flex items-end justify-center">
    {/* Dimmed background */}
    <div
      className="absolute inset-0 bg-black opacity-40"
      onClick={() => setShowVendorPopup(false)}
    />

    {/* Popup container */}
    <div className="relative w-full max-w-2xl bg-white shadow-2xl rounded-t-2xl p-6 z-50">
      <p className="text-lg font-semibold mb-6">Select a Tile Brand</p>

      {/* Vendor list */}
      {Object.entries(initialVendors).map(([vendorId, vendor]) => (
        <Fragment key={vendorId}>
          <label className="flex items-start justify-between mb-4 p-4 rounded-lg border border-gray-200 cursor-pointer hover:bg-gray-50 transition">
            {/* Left: Radio + Vendor Info */}
            <div className="flex items-start space-x-3 w-1/3">
              <input
                type="radio"
                name="vendor"
                value={vendor._id}
                checked={selectedVendor === vendor._id}
                onChange={() => handleRadioChange(vendor._id)}
                className="mt-4 w-3 h-3 accent-[#C20C0C]"
              />
              <div className="flex flex-col items-start">
                <img
                  src={process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES + vendor.image}
                  alt={vendor.name}
                  className="w-10 h-10 rounded-lg mb-1 border"
                />
                <p className="text-sm font-medium">{vendor.name}</p>
              </div>
            </div>

            {/* Right: Products & Prices */}
            <div className="w-2/3 grid grid-cols-2 gap-x-4 gap-y-2 text-sm text-gray-700">
              {vendor.product_subcategory_data.map((product) => (
                <Fragment key={product._id}>
                  <span className="font-semibold">{product.product_sub_category_name}</span>
                  <span className="text-right">
                    ₹{product.selling_price}
                    <span className="text-[11px] text-gray-400 font-normal"> /Box</span>
                  </span>
                </Fragment>
              ))}
            </div>
          </label>
        </Fragment>
      ))}

      {/* Footer Buttons */}
      <div className="flex justify-end mt-6 gap-4">
        <button
          onClick={() => setShowVendorPopup(false)}
          className="px-4 py-2 rounded-md text-sm font-medium border border-[#C20C0C] text-[#C20C0C] focus:outline-none focus:ring-2 focus:ring-[#C20C0C]"
        >
          Cancel
        </button>
        <button
          onClick={handleVendorChange}
          className="px-4 py-2 rounded-md text-sm font-medium bg-[#C20C0C] text-white hover:bg-[#a20a0a] focus:outline-none focus:ring-2 focus:ring-[#C20C0C]"
        >
          Apply Change
        </button>
      </div>
    </div>
  </div>
)}

{/* Vendors list popup ends */}

{/* Unapplied Areas Section - Only shown when there are unapplied areas */}
{unappliedAreas.length > 0 && (
  <div className="mt-2 mb-2 p-4 bg-[#FAD5D5] rounded-lg">
    <p className="text-sm mb-2 text-black">
      The following areas are not assigned to any tile. Select a tile and click "Apply" to assign them.
    </p>
    <div className="grid grid-cols-2 gap-2 mt-2">
      {unappliedAreas.slice(0, Math.max(4, visibleAreas)).map((area) => {
        // Pre-compute the selection state to avoid lag
        const isSelected = selectedUnappliedAreas.some(a => a._id === area._id);
        
        return (
          <button
            key={area._id || area.area_name}
            className={`py-1 text-xs border ${
              isSelected
                ? 'bg-[#C20C0C] text-white border-[#C20C0C]'
                : 'border-[#C20C0C] text-black bg-white'
            } rounded hover:bg-[#C20C0C] hover:text-white transition-colors flex items-center justify-center`}
            onClick={() => handleUnappliedAreaSelect(area)}
          >
            <span>{area.area_name}</span>
            {isSelected && (
              <svg className="w-3 h-3 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
              </svg>
            )}
          </button>
        );
      })}
    </div>
    {unappliedAreas.length > Math.max(4, visibleAreas) && (
      <button
        onClick={() => setVisibleAreas(prev => prev + 4)}
        className="mt-2 text-xs text-black hover:underline focus:outline-none"
      >
        Show more ({unappliedAreas.length - Math.max(4, visibleAreas)} remaining)
      </button>
    )}
    
    {selectedUnappliedAreas.length > 0 && (
      <div className="mt-3 flex justify-between items-center">
        <span className="text-xs text-black">
          {selectedUnappliedAreas.length} area{selectedUnappliedAreas.length > 1 ? 's' : ''} selected
        </span>
        <button
          onClick={() => setShowUnappliedAreaPopup(true)}
          className="px-3 py-1 text-xs bg-[#C20C0C] text-white rounded hover:bg-[#A00A0A] transition-colors"
        >
          Apply
        </button>
      </div>
    )}
  </div>
)}




{/* Bottom Popup for Unapplied Areas */}
{showUnappliedAreaPopup && (
  <div className="fixed inset-0 bg-black bg-opacity-50 z-40 flex justify-center items-center">
    {/* Overlay Background */}
    <div className="fixed inset-0 bg-black bg-opacity-50 z-40" onClick={() => setShowUnappliedAreaPopup(false)}></div>

    {/* Popup */}
    <div className="fixed bottom-0 left-0 right-0 bg-white p-4 z-50 shadow-2xl rounded-t-2xl transform transition-transform duration-300 ease-out">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-medium">Select a tile type to apply for</h3>
        <button onClick={() => setShowUnappliedAreaPopup(false)} className="text-gray-500">
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>

      <div className="mb-4">
        <p className="text-sm mb-2"></p>
        <div className="flex flex-wrap gap-2">
          {selectedUnappliedAreas.map(area => (
            <span key={area._id} className="px-2 py-1 bg-gray-100 text-xs rounded-full">
              {area.area_name}
            </span>
          ))}
        </div>
      </div>

      {/* Display Subcategories and Finishes - Similar to your showRoomPopup */}
      <div className="pb-2">
        <p className="font-medium mb-2">Select a Tile Type</p>
        {Array.from(
          new Set(
            Object.values(updatedSampleData.vendors)
              .flatMap(vendor => vendor.product_subcategory_data)
              .map(subcategory => subcategory.product_sub_category_name)
          )
        ).map(subcategoryName => {
          const subcategory = Object.values(updatedSampleData.vendors)
            .flatMap(vendor => vendor.product_subcategory_data)
            .find(sub => sub.product_sub_category_name === subcategoryName);

          return (
            <div key={subcategory._id} className="flex flex-row justify-between mb-3">
              <p className="font-medium mb-1">{subcategory.product_sub_category_name}</p>
              <div className="flex flex-wrap gap-3">
                {Array.from(
                  new Set(
                    updatedSampleData.items
                      .filter(item =>
                        item.product_subcategory.name === subcategory.product_sub_category_name &&
                        item.attributes?.some(attr => attr.attribute_name === "finish")
                      )
                      .flatMap(item =>
                        item.attributes.filter(attr => attr.attribute_name === "finish")
                      )
                      .map(attr => attr.attribute_value)
                  )
                ).map(finishValue => {
                  const finishAttribute = updatedSampleData.items
                    .flatMap(item => item.attributes || [])
                    .find(attr =>
                      attr.attribute_name === "finish" && attr.attribute_value === finishValue
                    );

                  return (
                    <label key={finishAttribute.attribute_value_id || finishValue} className="inline-flex items-center">
                      <input
                        type="radio"
                        name={`unapplied_finish_${subcategory._id}`}
                        value={finishValue}
                        checked={
                          selectedSubCategory === subcategory.product_sub_category_name &&
                          selectedFinish?.attribute_value === finishValue
                        }
                        onChange={() => handleFinishChange(subcategory.product_sub_category_name, finishAttribute)}
                        className="mr-2"
                      />
                      {finishValue}
                    </label>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>

      <div className="flex justify-end mt-4 space-x-2">
        <button
          onClick={() => setShowUnappliedAreaPopup(false)}
          className="px-4 py-2 rounded-md text-sm font-medium border border-[#C20C0C] text-[#C20C0C] hover:bg-gray-100"
        >
          Cancel
        </button>
        <button
          onClick={handleApplyUnappliedAreas}
          className="px-4 py-2 rounded-md text-sm font-medium bg-[#C20C0C] text-white hover:bg-[#A00A0A]"
          disabled={!selectedFinish || !selectedSubCategory}
        >
          Apply
        </button>
      </div>
    </div>
  </div>
)}



{/* Tiles Selections Div starts */}
<div className="p-4 mb-24"> {/* Tiles Selections */}
        <h3 className="mb-2 text-base font-semibold">Change Selections</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
  {updatedSampleData.items
    .filter(item => item.applied_areas && item.applied_areas.length > 0) // ✅ Only show items with applied_areas
    .map((item) => (
      <div key={item.vendor_id + item.item_name} className=" shadow-md bg-white border border-gray-200  rounded-lg overflow-hidden">
        <div className="px-4 py-2">
        <div className='mb-2 flex flex-row justify-between items-center p-1'>
        <div className='flex items-start space-x-3 mr-3 w-full'>
  {/* Vendor image */}
  <img
  src={process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES + item.vendor.image}
  alt={item.vendor.name}
  className="border border-gray-200 w-12 h-12 rounded-lg object-contain flex-shrink-0 cursor-pointer hover:shadow-md transition-shadow"
  onClick={() => handleVendorImageClick(item.vendor)}
/>

  
  {/* Item details container */}
  <div className="flex-1 min-w-0">
    {/* Primary item name with improved readability */}
    <h5 className="text-[#3C5DB1] font-semibold leading-tight mb-1">
      {/* First line with normal styling */}
     {/*  <span className="block text-md truncate">
        {item.item_name.split(' ').slice(0, 3).join(' ')}
      </span> */}
      
      {/* Second line with subtle styling difference */}
     {/*  {item.item_name.split(' ').length > 3 && (
        <span className="block text-base text-[#3C5DB1]/90 truncate">
          {item.item_name.split(' ').slice(3).join(' ')}
        </span>
      )} */}
      <span className="text-gray-700 text-md font-semibold line-clamp-2">{item.vendor.name}</span>
    </h5>
    
    {/* Attributes badges */}
    <div className="flex flex-row items-center gap-1 mt-1">
  {/* Show finish type prominently with color coding */}
  {item.attributes?.find(attr => attr.attribute_name === "finish") && (() => {
    const finishValue = item.attributes.find(attr => attr.attribute_name === "finish").attribute_value;
    const finishValueLower = finishValue.toLowerCase();
    
    // Determine color based on finish type
    let bgColor, textColor;
    if (finishValueLower.includes('glossy')) {
      bgColor = 'bg-gray-200';
      textColor = 'text-gray-800';
    } else if (finishValueLower.includes('matt') || finishValueLower.includes('matte')) {
      bgColor = 'bg-gray-200';
      textColor = 'text-gray-800';
    } else if (finishValueLower.includes('rustic') || finishValueLower.includes('textured')) {
      bgColor = 'bg-red-100';
      textColor = 'text-red-800';
    } else {
      bgColor = 'bg-gray-100';
      textColor = 'text-gray-800';
    }
    
    return (
      <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-sm font-medium ${bgColor} ${textColor}`}>
        {finishValue}
      </span>
    );
  })()}
  
  {/* Show size if available with color coding */}
  {item.attributes?.find(attr => attr.attribute_name === "size") && (() => {
    const sizeValue = item.attributes.find(attr => attr.attribute_name === "size").attribute_value;
    const sizeValueNormalized = sizeValue.toLowerCase().replace(/\s+/g, '');
    
    // Helper function to check size regardless of "mm" format
    const checkSize = (size) => {
      const pattern = size.replace(/x/g, '\\s*[xX]\\s*').replace(/mm/g, '\\s*(?:mm|MM|Mm|mM)?');
      return new RegExp(pattern, 'i').test(sizeValueNormalized);
    };
    
    // Determine color based on size - avoiding yellow
    let bgColor, textColor;
    if (checkSize('600x1200mm') || checkSize('1200x600mm')) {
      bgColor = 'bg-gray-200';
      textColor = 'text-gray-800';
    } else if (checkSize('600x600mm')) {
      bgColor = 'bg-gray-100';
      textColor = 'text-gray-800';
    } else if (checkSize('1200x1800mm') || checkSize('1800x1200mm')) {
      bgColor = 'bg-gray-200';
      textColor = 'text-gray-800';
    } else if (checkSize('800x1600mm') || checkSize('1600x800mm')) {
      bgColor = 'bg-gray-100';
      textColor = 'text-gray-800';
    } else if (checkSize('600x300mm') || checkSize('300x600mm')) {
      bgColor = 'bg-gray-100';
      textColor = 'text-gray-800';
    } else {
      bgColor = 'bg-gray-100';
      textColor = 'text-gray-700';
    }
    
    return (
      <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${bgColor} ${textColor}`}>
        {sizeValue}
      </span>
    );
  })()}
</div>

  </div>
</div>

  
{/*   <button 
      className="border border-[#e8001c] text-[#e8001c] text-xs font-medium py-1 px-3 rounded-md hover:bg-[#e8001c] hover:text-white transition-colors"
      >
    Change
  </button>  */}
</div>


<div className="pt-2 border-t border-gray-200 mb-3">
  {/* Two-row horizontal scrollable container with gray-50 background */}
  <div className="border border-gray-200 shadow-sm bg-gray-50 rounded-lg p-2">
    {/* Header with title */}
    <div className="flex justify-between items-center mb-2">
      <p className="text-sm font-medium text-gray-700">Applied Areas</p>
      
      {/* Scroll indicator - only show if there are more than 4 areas */}
      {item.applied_areas.length > 4 && (
        <span className="text-xs text-gray-500 flex items-center">
          <span>Scroll to see more</span>
          <svg className="w-3 h-3 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
          </svg>
        </span>
      )}
    </div>
    
    {/* Scrollable areas container with ref for scroll tracking */}
    <div 
  className="overflow-x-auto max-h-full mb-2"
  style={{ 
    scrollbarWidth: 'none',       /* Firefox */
    msOverflowStyle: 'none',      /* IE and Edge */
    WebkitOverflowScrolling: 'touch'  /* Smooth scrolling on iOS */
  }}
  ref={el => {
    // Store the scroll container reference in a map using item.item_id as key
    if (!window.areaScrollContainers) window.areaScrollContainers = new Map();
    if (el) {
      window.areaScrollContainers.set(item.item_id, el);
      
      // Add scroll event listener
      el.addEventListener('scroll', () => {
        const containerWidth = el.clientWidth;
        const totalWidth = el.scrollWidth;
        const scrollPosition = el.scrollLeft;
        
        // Calculate which page we're on (0-based index)
        const totalPages = Math.ceil(item.applied_areas.length / 4);
        const pageWidth = totalWidth / totalPages;
        const currentPage = Math.min(
          Math.floor(scrollPosition / pageWidth),
          totalPages - 1
        );
        
        // Update active dot
        const dots = document.querySelectorAll(`.pagination-dots-${item.item_id} .dot`);
        dots.forEach((dot, i) => {
          if (i === currentPage) {
            dot.classList.add('bg-[#e8001c]');
            dot.classList.remove('bg-gray-300');
          } else {
            dot.classList.add('bg-gray-300');
            dot.classList.remove('bg-[#e8001c]');
          }
        });
      });
      
      // Hide WebKit scrollbar directly on the element
      el.style.webkitScrollbar = 'none';
      el.style.setProperty('::-webkit-scrollbar', 'display: none');
    }
  }}
>

      <div className="w-max min-w-full"> {/* Forces container to expand with content but be at least full width */}
        <div className="grid grid-rows-2 grid-flow-col gap-x-2 gap-y-2 text-xs">
          {item.applied_areas.map((area, index) => (
            <div
              key={area._id}
              className="flex items-center w-[150px] bg-white rounded-md shadow-sm p-1.5 border border-gray-100"
              style={{ gridRow: index % 2 === 0 ? 1 : 2 }} // Alternates between first and second row
            >
              <div className="rounded-full flex items-center justify-center mr-1.5">
                <img
                  src={getRoomIcon(area.area_name)}
                  alt={area.area_name}
                  className="h-12 w-14 object-contain"
                />
              </div>
              <span className="font-semibold text-gray-700 line-clamp-2">{area.area_name}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
    
    {/* Pagination dots - Only show if there are more than 4 areas */}
    {item.applied_areas.length > 4 && (
      <div className={`flex justify-center items-center mb-2 pagination-dots-${item.item_id}`}>
        {/* Calculate number of "pages" based on 4 items per page (2 rows x 2 columns) */}
        {Array.from({ length: Math.ceil(item.applied_areas.length / 4) }).map((_, i) => (
          <div 
            key={i}
            className={`h-1.5 w-1.5 rounded-full mx-0.5 dot ${
              i === 0 ? 'bg-[#e8001c]' : 'bg-gray-300'
            }`}
            onClick={() => {
              // Scroll to this page when dot is clicked
              const container = window.areaScrollContainers.get(item.item_id);
              if (container) {
                const totalWidth = container.scrollWidth;
                const totalPages = Math.ceil(item.applied_areas.length / 4);
                const pageWidth = totalWidth / totalPages;
                container.scrollTo({
                  left: i * pageWidth,
                  behavior: 'smooth'
                });
              }
            }}
          ></div>
        ))}
      </div>
    )}
    
    {/* Fixed footer with Change button */}
    <div className="flex justify-end">
      <button
        onClick={() => handleRoomChangeClick(item)}
        className="border border-[#e8001c] text-[#e8001c] text-xs font-medium py-1 px-3 rounded-md hover:bg-[#e8001c] hover:text-white transition-colors"
      >
        Change
      </button>
    </div>
  </div>
</div>


          <div className="mt-2 flex justify-end items-center">
            <p className="text-lg font-semibold text-[#14A311]">₹{Number(item.total).toLocaleString('en-IN')}</p>
          </div>
        </div>
      </div>
    ))}
</div>

      </div>
      {/* Tiles Selections Div ends */}

     {/*  Footer starts */}
     <div className="border-t border-gray-300 fixed bottom-0 left-0 right-0 bg-white shadow-lg p-4 flex justify-between items-center z-10">
  {/* Price information with improved styling */}
  <div className="flex flex-col">
  <p className="text-md font-semibold">Total Price</p>
    <div className="flex flex-col items-baseline">
      <span className="text-xl font-bold text-[#14A311]">₹{Number(updatedSampleData.subtotal).toLocaleString('en-IN')}</span>
      <span className="text-xs text-gray-500 ml-1">(+ GST & Transport)</span>
    </div>
  </div>
  
  {/* Action buttons with improved styling */}
  <div className="flex space-x-3">
    <button 
      onClick={() => navigate(-1)}
      className="px-4 py-2 rounded-md text-sm font-medium border border-gray-300 text-gray-700 bg-white hover:bg-gray-50 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
    >
      Cancel
    </button>
    <button 
      onClick={handleSaveQuote}
      className="px-4 py-2 rounded-md text-sm font-medium bg-[#e8001c] text-white hover:bg-[#e8001c] transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#e8001c]"
    >
      Save Changes
    </button>
  </div>
</div>
         {/*  Footer ends */}



                   {/* Room Popup */}
 {showRoomPopup && (
  <div className="fixed inset-0 bg-black bg-opacity-50 z-40 flex justify-center items-center">
    {/* Overlay Background */}
    <div className="fixed inset-0 bg-black bg-opacity-50 z-40" onClick={handleCloseShowRoomPopup}></div>
    
    {/* Popup */}
    <div className="fixed bottom-0 left-0 right-0 bg-white z-50 shadow-2xl rounded-t-2xl transform transition-transform duration-300 ease-out h-[85vh] flex flex-col">
      {/* Fixed Header - stays at the top */}
      <div className="px-4 pt-4 pb-2 border-b border-gray-200 flex-shrink-0">
        <div className="flex justify-between items-center">
          <h3 className="text-lg font-semibold text-gray-900">Select areas and apply tile</h3>
          <button
          className="text-sm font-medium text-[#e8001c] hover:text-[#e8001c] whitespace-nowrap disabled:opacity-50"
          onClick={() => {
            setSelectedRooms(prev => {
              const newRooms = {};
              Object.keys(prev).forEach(room => {
                newRooms[room] = {...prev[room], selected: false};
              });
              return newRooms;
            });
            setSelectedFinish(null);
            setSelectedSubcategory(null);
          }}
          disabled={isApplying}
        >
          Clear All
        </button>
          <button
            onClick={handleCloseShowRoomPopup}
            className="text-gray-500 hover:text-gray-700 focus:outline-none"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>
      </div>
      
      {/* Scrollable Content Area */}
      <div className="flex-grow overflow-y-auto ">
        {/* Areas Section - Horizontal Scrolling */}
        <div className="px-4 pt-4 mb-4">
  {/* Current Item Section - High Priority */}
  <div className="bg-white rounded-lg p-4 shadow-sm border border-gray-200 mb-4">
  {/* Section Header with Visual Indicator */}
  <div className="flex items-center mb-3 border-b pb-2">
    <div className="w-1 h-5 bg-[#e8001c] rounded-full mr-2"></div>
    <h3 className="text-[#e8001c] text-md font-semibold flex-1">Currently Applied</h3>
  </div>
  
  {/* Item Details */}
  <div className="flex items-start">
    <div className="flex-1">
        <div className="flex items-center mb-2">
            <img
              src={process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES + selectedItem.vendor.image}
              alt={selectedItem.vendor.name}
              className="w-10 h-10 mr-2 border border-gray-200 rounded-sm"
            />
            <div>
            <span className="text-md font-semibold text-gray-800">{selectedItem.vendor.name}</span>
            <div className="flex flex-wrap items-center gap-1 mt-1">
        {/* Show finish type prominently with color coding */}
        {selectedItem.attributes?.find(attr => attr.attribute_name === "finish") && (() => {
          const finishValue = selectedItem.attributes.find(attr => attr.attribute_name === "finish").attribute_value;
          const finishValueLower = finishValue.toLowerCase();
          
          // Determine color based on finish type
          let bgColor, textColor;
          if (finishValueLower.includes('glossy')) {
            bgColor = 'bg-gray-200';
            textColor = 'text-gray-800';
          } else if (finishValueLower.includes('matt') || finishValueLower.includes('matte')) {
            bgColor = 'bg-gray-100';
            textColor = 'text-gray-800';
          } else if (finishValueLower.includes('rustic') || finishValueLower.includes('textured')) {
            bgColor = 'bg-gray-100';
            textColor = 'text-gray-800';
          } else {
            bgColor = 'bg-gray-100';
            textColor = 'text-gray-800';
          }
          
          return (
            <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${bgColor} ${textColor}`}>
              {finishValue}
            </span>
          );
        })()}
        
        {/* Show size if available with color coding */}
        {selectedItem.attributes?.find(attr => attr.attribute_name === "size") && (() => {
          const sizeValue = selectedItem.attributes.find(attr => attr.attribute_name === "size").attribute_value;
          const sizeValueNormalized = sizeValue.toLowerCase().replace(/\s+/g, '');
          
          // Helper function to check size regardless of "mm" format
          const checkSize = (size) => {
            const pattern = size.replace(/x/g, '\\s*[xX]\\s*').replace(/mm/g, '\\s*(?:mm|MM|Mm|mM)?');
            return new RegExp(pattern, 'i').test(sizeValueNormalized);
          };
          
          // Determine color based on size - avoiding yellow
          let bgColor, textColor;
          if (checkSize('600x1200mm') || checkSize('1200x600mm')) {
            bgColor = 'bg-gray-200';
            textColor = 'text-gray-800';
          } else if (checkSize('600x600mm')) {
            bgColor = 'bg-gray-200';
            textColor = 'text-gray-800';
          } else if (checkSize('1200x1800mm') || checkSize('1800x1200mm')) {
            bgColor = 'bg-gray-200';
            textColor = 'text-gray-800';
          } else if (checkSize('800x1600mm') || checkSize('1600x800mm')) {
            bgColor = 'bg-pink-100';
            textColor = 'text-pink-800';
          } else if (checkSize('600x300mm') || checkSize('300x600mm')) {
            bgColor = 'bg-teal-100';
            textColor = 'text-teal-800';
          } else {
            bgColor = 'bg-gray-100';
            textColor = 'text-gray-700';
          }
          
          return (
            <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${bgColor} ${textColor}`}>
              {sizeValue}
            </span>
          );
        })()}
      </div>
</div>
          </div>
      
    </div>
  </div>
      <div className='border border-gray-100'></div>
      <div className='flex flex-row items-center'>
      <p className='mt-2 text-sm font-bold text-gray-700'>Applied Areas</p>
      <p className='text-[#e8001c] ml-1.5 mt-2 text-xs'>(Select multiple areas to apply a tile)</p>
</div>
  {/* Scrollable Areas */}
  <div className="flex overflow-x-auto p-1 space-x-2 no-scrollbar">
    {/* Show recently moved areas FIRST where originalItemId matches selectedItem.item_id */}
    {recentlyAddedAreas
      .filter(area => area.newItemId === selectedItem.item_id)
      .map(area => {
        // Check if this area is also in selectedRooms
        const isInSelectedRooms = selectedRooms[area.area_name];
        const isSelected = isInSelectedRooms?.selected;
        
        return (
          <div
            key={`recent-${area.area_name}-${area.timestamp}`}
            className={`flex-shrink-0 p-3 rounded-md border min-w-[150px] cursor-pointer transition-all duration-200 relative ${
              isSelected
                ? 'border-[#C20C0C] bg-[#FFF5F5] text-[#C20C0C] shadow-md transform -translate-y-1 z-10'
                : 'border-gray-300 text-gray-700 hover:border-gray-300 hover:shadow-sm'
            }`}
            onClick={() => {
              // If area is in selectedRooms, use handleCheckboxChange
              // Otherwise, add it to selectedRooms first and then select it
              if (isInSelectedRooms) {
                handleCheckboxChange(area.area_name);
              } else {
                setSelectedRooms(prev => ({
                  ...prev,
                  [area.area_name]: {
                    _id: area._id,
                    area_name: area.area_name,
                    areaInSft: area.areaInSft,
                    selected: true,
                    fromSelectedItem: false,
                  },
                }));
              }
            }}
          >
            <div className="flex items-center justify-between">
              <span className="text-md truncate">{area.area_name}</span>
              {isSelected && (
                <svg className="w-4 h-4 text-[#C20C0C]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                </svg>
              )}
            </div>
            <div className='flex flex-row justify-between items-center'>
              <div className="text-xs mt-1">
                {area.areaInSft} sq.ft
              </div>
            </div>
          </div>
        );
      })}
    
    {/* THEN show current selectable rooms */}
    {Object.keys(selectedRooms).map(room => {
      const isSelected = selectedRooms[room]?.selected;
      
      // Skip rendering if this room is already shown in the recently added areas
      const isAlreadyShownInRecent = recentlyAddedAreas.some(
        area => area.area_name === room && area.originalItemId === selectedItem.item_id
      );
      
      if (isAlreadyShownInRecent) return null;
      
      return (
        <div
          key={room}
          className={`flex-shrink-0 p-3 rounded-md border min-w-[150px] cursor-pointer transition-all duration-200 relative ${
            isSelected
              ? 'border-[#C20C0C] bg-[#FFF5F5] text-[#C20C0C] shadow-md transform -translate-y-1 z-10'
              : 'border-gray-300 text-gray-700 hover:border-gray-300 hover:shadow-sm'
          }`}
          onClick={() => handleCheckboxChange(room)}
        >
          <div className="flex items-center justify-between">
            <span className="text-md truncate">{selectedRooms[room]?.area_name}</span>
          </div>
          <div className="text-xs mt-1">
            {selectedRooms[room]?.areaInSft} sq.ft
          </div>
        </div>
      );
    })}
  </div>
</div>

  
  {/* Recently Added Areas Section - Secondary Priority */}
  {(() => {
  // First, filter out areas where selectedItem.item_id matches area.newItemId
  const filteredAreas = recentlyAddedAreas
    .filter(area => !(selectedItem && selectedItem.item_id && area.newItemId === selectedItem.item_id));
  
  // Group areas by item name
  const groupedAreas = filteredAreas.reduce((acc, area) => {
    const name = area.newItemName || area.itemName || 'Untitled';
    if (!acc[name]) acc[name] = [];
    acc[name].push(area);
    return acc;
  }, {});
  
  // Check if there are any groups with areas after filtering
  const hasAreasToDisplay = Object.values(groupedAreas).some(areas => areas.length > 0);
  
  // Only render the section if there are areas to display
  if (!hasAreasToDisplay) return null;
  
  return (
    <div className="bg-gray-100 rounded-lg p-4 border border-gray-200 shadow-sm mb-4">
      {/* Enhanced Section Header with Better Visual Indicator */}
      <div className="flex items-center mb-3 border-b pb-2">
        <div className="w-1 h-5 bg-[#e8001c] rounded-full mr-2"></div>
        <h3 className="text-[#e8001c] text-md font-semibold flex-1">Newly Applied</h3>
      </div>
      
      {Object.entries(groupedAreas).map(([itemName, areas]) => {
        // Skip rendering if there are no areas left after filtering
        if (areas.length === 0) return null;
        
        // Find the matching item to extract attributes and vendor information
        const matchingItem = updatedSampleData.items.find(item => 
          item.item_name === itemName
        );
        
        // Extract finish attribute if available
        const finishAttr = matchingItem?.attributes?.find(attr => 
          attr.attribute_name === "finish"
        );
        
        // Extract size attribute if available
        const sizeAttr = matchingItem?.attributes?.find(attr => 
          attr.attribute_name === "size"
        );
        
        // Get vendor information
        const vendorImage = matchingItem?.vendor?.image;
        const vendorName = matchingItem?.vendor?.name;
        
        return (
          <div key={itemName} className="mb-5 pb-4 border-b border-gray-200 last:border-0 last:mb-0 last:pb-0">
            {/* Enhanced item header with vendor image and name */}
            <div className="flex items-start gap-2 mb-2">
              {/* Vendor image */}
              {vendorImage && (
                <img
                  src={process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES + vendorImage}
                  alt={vendorName || "Vendor"}
                  className="bg-white w-10 h-10 border border-gray-200 rounded-sm"
                />
              )}
              
              <div className="flex-1">
                {/* Vendor name */}
                <p className="text-md font-semibold text-gray-800">{vendorName || "Unknown Vendor"}</p>
                
                {/* Attributes badges */}
                <div className='flex flex-wrap gap-1 mt-1'>
                  {/* Finish attribute badge with color coding */}
                  {finishAttr && (() => {
                    const finishValue = finishAttr.attribute_value;
                    const finishValueLower = finishValue.toLowerCase();
                    
                    // Determine color based on finish type
                    let bgColor, textColor;
                    if (finishValueLower.includes('glossy')) {
                      bgColor = 'bg-gray-200';
                      textColor = 'text-gray-800';
                    } else if (finishValueLower.includes('matt') || finishValueLower.includes('matte')) {
                      bgColor = 'bg-gray-200';
                      textColor = 'text-gray-800';
                    } else if (finishValueLower.includes('rustic') || finishValueLower.includes('textured')) {
                      bgColor = 'bg-gray-100';
                      textColor = 'text-gray-800';
                    } else {
                      bgColor = 'bg-gray-100';
                      textColor = 'text-gray-800';
                    }
                    
                    return (
                      <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${bgColor} ${textColor}`}>
                        {finishValue}
                      </span>
                    );
                  })()}
                  
                  {/* Size attribute badge with color coding */}
                  {sizeAttr && (() => {
                    const sizeValue = sizeAttr.attribute_value;
                    const sizeValueNormalized = sizeValue.toLowerCase().replace(/\s+/g, '');
                    
                    // Helper function to check size regardless of "mm" format
                    const checkSize = (size) => {
                      const pattern = size.replace(/x/g, '\\s*[xX]\\s*').replace(/mm/g, '\\s*(?:mm|MM|Mm|mM)?');
                      return new RegExp(pattern, 'i').test(sizeValueNormalized);
                    };
                    
                    // Determine color based on size - avoiding yellow
                    let bgColor, textColor;
                    if (checkSize('600x1200mm') || checkSize('1200x600mm')) {
                      bgColor = 'bg-gray-200';
                      textColor = 'text-gray-800';
                    } else if (checkSize('600x600mm')) {
                      bgColor = 'bg-gray-200';
                      textColor = 'text-gray-800';
                    } else if (checkSize('1200x1800mm') || checkSize('1800x1200mm')) {
                      bgColor = 'bg-gray-200';
                      textColor = 'text-gray-800';
                    } else if (checkSize('800x1600mm') || checkSize('1600x800mm')) {
                      bgColor = 'bg-gray-100';
                      textColor = 'text-gray-800';
                    } else if (checkSize('600x300mm') || checkSize('300x600mm')) {
                      bgColor = 'bg-gray-100';
                      textColor = 'text-gray-800';
                    } else {
                      bgColor = 'bg-gray-100';
                      textColor = 'text-gray-700';
                    }
                    
                    return (
                      <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${bgColor} ${textColor}`}>
                        {sizeValue}
                      </span>
                    );
                  })()}
                </div>
              </div>
            </div>
            <div className='border borer-gray-50'></div>

            <div className='flex flex-row items-center'>
      <p className='mt-2 text-sm font-bold text-gray-700'>Applied Areas</p>
      <p className='text-[#e8001c] ml-1.5 mt-2 text-xs'>(Select multiple areas to apply a tile)</p>
</div>
            {/* Areas with enhanced visual cues */}
            <div className="flex overflow-x-auto py-2 px-1 space-x-3 no-scrollbar">
              {areas.map((area) => {
                const isSelected = selectedRooms[area.area_name]?.selected;
                
                return (
                  <div
                    key={`${area.area_name}-${area.timestamp}`}
                    className={`flex-shrink-0 p-3 rounded-md border min-w-[150px] cursor-pointer transition-all duration-200 relative ${
                      isSelected
                        ? 'border-[#C20C0C] bg-[#FFF5F5] text-[#C20C0C] shadow-md transform -translate-y-1 z-10'
                        : 'border-gray-300 bg-white text-gray-700 hover:border-gray-400 hover:shadow-sm'
                    }`}
                    onClick={() => {
                      // Toggle selection state when clicked
                      if (isSelected) {
                        // If already selected, deselect it
                        setSelectedRooms(prev => ({
                          ...prev,
                          [area.area_name]: {
                            ...prev[area.area_name],
                            selected: false
                          }
                        }));
                      } else {
                        // If not selected, select it (using the existing handleReapplyRecentArea function)
                        handleReapplyRecentArea(area);
                      }
                    }}
                  >
                    
                    {/* Main content with area name and checkbox */}
                    <div className="flex items-center justify-between mb-1">
                      <span className="text-md font-medium truncate">{area.area_name}</span>
                    </div>
                    
                    <div className='flex justify-between items-center'>
                      {/* Area size */}
                      <div className="text-xs text-gray-600">{area.areaInSft} sq.ft</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
})()}

</div>
              
        {/* Divider */}
        <div className="border-t border-gray-200"></div>
        
        {/* Tiles Selection Section */}
        <div className="p-4 mb-4">
          <p className="text-md font-bold mb-2">Select Tile</p>
          <div className="grid grid-cols-2 gap-3">
  {updatedSampleData.items.map((item, index) => {
    const finishAttr = item.attributes?.find(attr => attr.attribute_name === "finish");
    const sizeAttr = item.attributes?.find(attr => attr.attribute_name === "size");
    const finishValue = finishAttr?.attribute_value || "N/A";
    
    const isItemSelected = 
      selectedSubCategory === item.product_subcategory.name && 
      selectedFinish?.attribute_value === finishValue;
    
    return (
      <div
        key={item.item_id || index}
        className={`p-3 rounded-lg border cursor-pointer transition-all ${
          isItemSelected
            ? 'border-[#C20C0C] bg-[#FFF5F5] shadow-md transform scale-105'
            : 'border-gray-200 hover:border-gray-300 hover:shadow'
        }`}
        onClick={() => {
          setSelectedSubcategory(item.product_subcategory.name);
          setSelectedFinish(finishAttr);
        }}
      >
        <div className="flex flex-col h-full">
          <div className="flex items-center mb-2">
            <img
              src={process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES + item.vendor.image}
              alt={item.vendor.name}
              className="w-8 h-8 mr-2 border border-gray-200 rounded-sm"
            />
            <span className="font-medium text-sm truncate">{item.vendor.name}</span>
          </div>
          
          <div className="text-xs text-gray-600 space-y-2">
            {/* Attribute badges instead of item name */}
            <div className="flex flex-wrap gap-1">
              {/* Finish badge with color coding */}
              {finishAttr && (() => {
                const finishValueLower = finishValue.toLowerCase();
                
                // Determine color based on finish type
                let bgColor, textColor;
                if (finishValueLower.includes('glossy')) {
                  bgColor = 'bg-gray-200';
                  textColor = 'text-gray-800';
                } else if (finishValueLower.includes('matt') || finishValueLower.includes('matte')) {
                  bgColor = 'bg-gray-200';
                  textColor = 'text-gray-800';
                } else if (finishValueLower.includes('rustic') || finishValueLower.includes('textured')) {
                  bgColor = 'bg-gray-100';
                  textColor = 'text-gray-800';
                } else {
                  bgColor = 'bg-gray-100';
                  textColor = 'text-gray-800';
                }
                
                return (
                  <span className={`inline-flex items-center px-2 py-1 rounded-md text-sm font-medium ${bgColor} ${textColor}`}>
                    {finishValue}
                  </span>
                );
              })()}
              
              {/* Size badge with color coding */}
              {sizeAttr && (() => {
                const sizeValue = sizeAttr.attribute_value;
                const sizeValueNormalized = sizeValue.toLowerCase().replace(/\s+/g, '');
                
                // Helper function to check size regardless of "mm" format
                const checkSize = (size) => {
                  const pattern = size.replace(/x/g, '\\s*[xX]\\s*').replace(/mm/g, '\\s*(?:mm|MM|Mm|mM)?');
                  return new RegExp(pattern, 'i').test(sizeValueNormalized);
                };
                
                // Determine color based on size - avoiding yellow
                let bgColor, textColor;
                if (checkSize('600x1200mm') || checkSize('1200x600mm')) {
                  bgColor = 'bg-gray-200';
                  textColor = 'text-gray-800';
                } else if (checkSize('600x600mm')) {
                  bgColor = 'bg-gray-200';
                  textColor = 'text-gray-800';
                } else if (checkSize('1200x1800mm') || checkSize('1800x1200mm')) {
                  bgColor = 'bg-gray-200';
                  textColor = 'text-gray-800';
                } else if (checkSize('800x1600mm') || checkSize('1600x800mm')) {
                  bgColor = 'bg-gray-100';
                  textColor = 'text-gray-800';
                } else if (checkSize('600x300mm') || checkSize('300x600mm')) {
                  bgColor = 'bg-gray-100';
                  textColor = 'text-gray-800';
                } else {
                  bgColor = 'bg-gray-100';
                  textColor = 'text-gray-700';
                }
                
                return (
                  <span className={`inline-flex items-center px-2 py-1 rounded-md text-xs font-medium ${bgColor} ${textColor}`}>
                    {sizeValue}
                  </span>
                );
              })()}
            </div>
            
            <p>Price: <span className="font-medium">₹{item.selling_price}/Box</span></p>
          </div>
        </div>
      </div>
    );
  })}
</div>

        </div>
      </div>
      
     {/* Fixed Footer - stays at the bottom */}

  <div className="px-4 py-3 border-t border-gray-200 flex-shrink-0 bg-white shadow-lg">
    <div className="flex justify-end items-center max-w-md mx-auto">
  <button 
    className={`min-w-[120px] mr-3 border px-4 py-2 rounded-md text-sm font-semibold ${
      selectedFinish && Object.values(selectedRooms).filter(room => room.selected).length > 0 && !isApplying
        ? 'bg-gray-300 text-gray-500 cursor-not-allowed border-gray-300'
        : 'bg-[#e8001c] text-white border-[#e8001c]'
    }`}
    onClick={handleCloseShowRoomPopup}
    disabled={selectedFinish && Object.values(selectedRooms).filter(room => room.selected).length > 0 && !isApplying}
  >
    Done Applying
  </button>
  <button
    onClick={handleModifiedRoomChange}
    disabled={!selectedFinish || Object.values(selectedRooms).filter(room => room.selected).length === 0 || isApplying}
    className={`px-4 py-2 rounded-md text-sm font-medium flex items-center justify-center ${
      !selectedFinish || Object.values(selectedRooms).filter(room => room.selected).length === 0 || isApplying
        ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
        : 'bg-[#e8001c] text-white hover:bg-[#e8001c]'
    } focus:outline-none min-w-[120px]`}
  >
    {isApplying ? (
      <>
        <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        Applying...
      </>
    ) : (
      'Apply'
    )}
  </button>
</div>
      </div>
    </div>
    </div>
)}

{showSaveConfirmPopup && (
  <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-end justify-center">
    <div className="bg-white rounded-t-xl p-6 w-full max-w-md shadow-xl">
      <div className="text-center mb-4">
        <div className="w-12 h-1 bg-gray-300 rounded-full mx-auto mb-4"></div>
        <p className="text-sm text-gray-700 mb-2">You have made changes in your
           <span className='ml-1.5 font-bold'>{updatedSampleData.quotation_number} </span>
           quotation</p>
        <p className="text-black font-bold mb-4">Would you like to:</p>
      </div>
      
      <div className="space-y-3">
        <button 
          onClick={handleReplaceOriginal}
          className="text-xs w-full py-3 px-4 bg-[#C20C0C] text-white rounded-lg font-medium hover:bg-[#A00A0A] transition-colors"
        >
          Replace original 
          <span className='text-sm ml-0.5 font-bold'>{updatedSampleData.quotation_number} </span>
          quotation
        </button>
        
        <button 
          onClick={handleSaveCopy}
          className="w-full py-3 px-4 border border-[#C20C0C] text-[#C20C0C] rounded-lg font-medium hover:bg-red-50 transition-colors"
        >
          Save a copy of updated quotation
        </button>
        
        <button 
          onClick={() => setShowSaveConfirmPopup(false)}
          className="w-full py-3 px-4 bg-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-300 transition-colors mt-2"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
)}

{/* Vendor Details Popup starts */}
{showVendorDetailsPopup && selectedVendorDetails && (
  <div className="fixed inset-0 bg-black/70 z-50 flex items-end sm:items-center justify-center">
    {/* Overlay with subtle fade effect */}
    <div 
      className="absolute inset-0 backdrop-blur-sm transition-opacity duration-300"
      onClick={() => setShowVendorDetailsPopup(false)}
    ></div>
    
    {/* Modern Card-style Popup */}
    <div className="relative bg-white rounded-t-2xl sm:rounded-2xl shadow-2xl w-full max-w-2xl mx-auto overflow-hidden animate-fade-in-up">
      {/* Premium Handle */}
      <div className="pt-3 flex justify-center">
        <div className="w-16 h-1.5 bg-gray-300/80 rounded-full"></div>
      </div>
      
      {/* Header with gradient */}
      <div className="relative">
        <div className="absolute inset-0 bg-gradient-to-r from-[#C20C0C]/10 to-[#3C5DB1]/10"></div>
        <div className="relative flex justify-between items-center p-5">
          <div>
            <h3 className="text-2xl font-bold text-gray-900">{selectedVendorDetails.name}</h3>
            <p className="text-sm text-gray-600 flex items-center">
              <FontAwesomeIcon icon={faStar} className="w-4 h-4 text-yellow-400 mr-1" />
              Premium Brand
            </p>
          </div>
          <button 
            onClick={() => setShowVendorDetailsPopup(false)}
            className="p-2 rounded-full bg-white/80 shadow-sm hover:bg-gray-100 transition-all"
          >
            <FontAwesomeIcon icon={faClose} className="w-5 h-5 text-gray-600" />
          </button>
        </div>
      </div>
      
      {/* Content with scroll-snap sections */}
      <div className="overflow-y-auto" style={{ maxHeight: '70vh' }}>
        {/* Hero Section */}
        <div className="relative h-48 bg-gradient-to-br from-gray-900 to-gray-700 flex items-center justify-center">
          <img
            src={process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES + selectedVendorDetails.image}
            alt={selectedVendorDetails.name}
            className="h-32 object-contain"
          />
          <div className="absolute bottom-4 right-4 bg-[#C20C0C] text-white px-3 py-1 rounded-full text-xs font-bold">
            Official Partner
          </div>
        </div>
        
        {/* Tab Navigation */}
        <div className="border-b border-gray-200 sticky top-0 bg-white z-10">
          <div className="flex px-5">
            <button className="px-4 py-3 font-medium text-[#C20C0C] border-b-2 border-[#C20C0C]">
              Overview
            </button>
            <button className="px-4 py-3 font-medium text-gray-500 hover:text-gray-700">
              Products
            </button>
            <button className="px-4 py-3 font-medium text-gray-500 hover:text-gray-700">
              Specifications
            </button>
          </div>
        </div>
        
        {/* Content Sections */}
        <div className="p-5 space-y-6">
          {/* Brand Story */}
          <div className="bg-gray-50/50 p-5 rounded-xl">
            <h4 className="text-lg font-semibold mb-3 flex items-center">
              <FontAwesomeIcon icon={faBookOpen} className="w-5 h-5 text-[#3C5DB1] mr-2" />
              Brand Story
            </h4>
            <p className="text-gray-700 leading-relaxed">
              {selectedVendorDetails.description || 
                `${selectedVendorDetails.name} redefines excellence in tile manufacturing with Italian technology and sustainable practices. Each piece reflects 40+ years of craftsmanship.`}
            </p>
          </div>
          
          {/* Featured Products - Card Grid */}
          <div>
            <h4 className="text-lg font-semibold mb-3 flex items-center">
              <FontAwesomeIcon icon={faCube} className="w-5 h-5 text-[#C20C0C] mr-2" />
              Featured Collections
            </h4>
            <div className="grid grid-cols-2 gap-4">
              {selectedVendorDetails.product_subcategory_data?.slice(0,4).map(subcategory => (
                <div key={subcategory._id} className="group relative overflow-hidden rounded-lg border border-gray-200 hover:shadow-md transition-all">
                  <div className="aspect-square bg-gray-100 flex items-center justify-center p-4">
                  <FontAwesomeIcon icon={faCube} className="w-10 h-10 text-gray-400 group-hover:text-[#C20C0C] transition-colors" />
                  </div>
                  <div className="p-3">
                    <h5 className="font-medium text-gray-900 truncate">{subcategory.product_sub_category_name}</h5>
                    <div className="flex justify-between items-center mt-2">
                      <span className="text-sm font-bold text-[#C20C0C]">₹{subcategory.selling_price}/Box</span>
                      <button className="text-xs bg-[#C20C0C]/10 text-[#C20C0C] px-2 py-1 rounded-full hover:bg-[#C20C0C]/20">
                        View
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          {/* Tech Specs */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold flex items-center">
              <FontAwesomeIcon icon={faCog} className="w-5 h-5 text-gray-700 mr-2" />
              Technical Advantages
            </h4>
            <div className="grid grid-cols-2 gap-3">
              <div className="bg-white p-3 rounded-lg border border-gray-200 shadow-sm">
                <div className="flex items-center mb-2">
                  <FontAwesomeIcon icon={faShield} className="w-5 h-5 text-green-500 mr-2" />
                  <span className="font-medium">Durability</span>
                </div>
                <p className="text-xs text-gray-600">10+ year warranty against wear and tear</p>
              </div>
              <div className="bg-white p-3 rounded-lg border border-gray-200 shadow-sm">
                <div className="flex items-center mb-2">
                  <FontAwesomeIcon icon={faSwatchbook} className="w-5 h-5 text-blue-500 mr-2" />
                  <span className="font-medium">Colorfast</span>
                </div>
                <p className="text-xs text-gray-600">UV-resistant colors that won't fade</p>
              </div>
              <div className="bg-white p-3 rounded-lg border border-gray-200 shadow-sm">
                <div className="flex items-center mb-2">
                  <FontAwesomeIcon icon={faRuler} className="w-5 h-5 text-purple-500 mr-2" />
                  <span className="font-medium">Eco-Friendly</span>
                </div>
                <p className="text-xs text-gray-600">40% recycled materials used</p>
              </div>
              <div className="bg-white p-3 rounded-lg border border-gray-200 shadow-sm">
                <div className="flex items-center mb-2">
                  <FontAwesomeIcon icon={faStarHalfStroke} className="w-5 h-5 text-yellow-500 mr-2" />
                  <span className="font-medium">Finish</span>
                </div>
                <p className="text-xs text-gray-600">Nano-coating for stain resistance</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Sticky CTA */}
      <div className="sticky bottom-0 bg-white border-t border-gray-200 p-4">
        <div className="flex justify-between items-center">
          <div>
            <p className="text-xs text-gray-500">Have questions?</p>
            <p className="font-medium">Talk to our tile expert</p>
          </div>
          <button className="bg-[#C20C0C] text-white px-6 py-2 rounded-full font-medium hover:bg-[#A00A0A] transition-colors flex items-center">
            <FontAwesomeIcon icon={faPhone} className="w-4 h-4 mr-2" />
            Call Now
          </button>
        </div>
      </div>
    </div>
  </div>
)}
 {/* vendor details popup ends */}
         </div>
  );
}

export default TilesCustomize;
